/**
 * Решение владельца №1 (2026-10-08, повтор эталона Slimkit): системный шрифт
 * (`fontId: 'system'`, themes/fonts.ts) рисуется со сглаживанием
 * `antialiased`, как у эталона (их `index.html`, `-webkit-font-smoothing`).
 * Для остальных id — пустой объект: вид старых воронок не меняется ни на байт.
 *
 * Отдельным модулем, а не в fonts.ts: наборы проверок, подменяющие
 * `@/themes/fonts` частичной заглушкой (PhonePreview.blockFont.test.tsx и
 * др.), не обязаны знать про сглаживание.
 *
 * Читатели: корень воронки (pages/funnel/funnelSurfaceStyle.ts) и обёртка
 * шрифта блока (components/editor/blockFont.tsx).
 */
export const SYSTEM_FONT_ID = 'system';

export function fontSmoothingStyle(fontId: string | undefined): {
  WebkitFontSmoothing?: 'antialiased';
  MozOsxFontSmoothing?: 'grayscale';
} {
  return fontId === SYSTEM_FONT_ID
    ? { WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale' }
    : {};
}
